import { store } from 'store';
import {
  setFacebookSdkLoadedAction,
  setMicrosoftTeamsLoadedAction,
  setYammerLoadedAction,
} from 'common/actions/settings';
import { setPlayerAnalyticsConsentAction } from 'common/actions';

export const usercentricsServiceNames = {
  facebook: 'Facebook Pixel',
  microsoftTeams: 'Microsoft Teams',
  vivaEngage: 'Viva Engage',
  playerAnalytics: 'Player Analytics',
};

export const usercentricsContentChangeEventListener = () => {
  window.addEventListener('ucEvent', function (event) {
    if (event.detail[usercentricsServiceNames.facebook]) {
      store.dispatch(setFacebookSdkLoadedAction());
    }

    if (event.detail[usercentricsServiceNames.microsoftTeams]) {
      store.dispatch(setMicrosoftTeamsLoadedAction());
    }

    if (event.detail[usercentricsServiceNames.vivaEngage]) {
      store.dispatch(setYammerLoadedAction());
    }

    if (usercentricsServiceNames.playerAnalytics in event.detail) {
      store.dispatch(setPlayerAnalyticsConsentAction(event.detail[usercentricsServiceNames.playerAnalytics]));
    }
  });
};
